import React from "react";

const InputComp = (props) => {

    return (
        props.isMulti ?
            <div class="form-group">
                <textarea
                    style={{ borderWidth: 1, borderColor: 'hsl(0, 0%, 50%)' }}
                    className="form-control rounded-0"
                    value={props.value}
                    onChange={(event) => { props.onChangeHandler(event.target.value) }}
                    rows={5}
                    disabled={props.isDisabled}
                />
            </div>
            :
            <input
                style={props.style}
                type="text"
                aria-label={props.labelName}
                aria-required="true"
                maxLength={props.maxLength}
                autoComplete="off"
                inputType={props.inputType ? props.inputType : 'none'}
                placeholder={
                    props.placeholder
                }
                value={props.value}
                disabled={props.isDisabled}
                inputProps={{ inputMode: props.inputType ? props.inputType : 'none' }}
                onChange={(event) => { props.onChangeHandler(event.target.value) }}
            />

    );
}

export default InputComp;